import { http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { WorkMaterialType } from './work-material-type.interface';

export class WorkMaterialTypeService {
   async getWorkMaterialTypes(employerId: number, query?: LocationQuery): Promise<ApiResource<Array<WorkMaterialType>>> {
      const response = await http.get<ApiResource<Array<WorkMaterialType>>>(`/employers/${employerId}/work-material-types`, {
         params: { ...query },
      });

      return response.data;
   }

   async getWorkMaterialType(
      employerId: number,
      workMaterialTypeId: number,
      query?: LocationQuery,
   ): Promise<ApiResource<WorkMaterialType>> {
      const response = await http.get<ApiResource<WorkMaterialType>>(`/employers/${employerId}/work-material-types/${workMaterialTypeId}`, {
         params: { ...query },
      });
      return response.data;
   }

   async postWorkMaterialType(employerId: number, workMaterialType: WorkMaterialType): Promise<ApiResource<WorkMaterialType>> {
      const response = await http.post<ApiResource<WorkMaterialType>>(`/employers/${employerId}/work-material-types`, workMaterialType);
      return response.data;
   }

   async putWorkMaterialType(
      employerId: number,
      workMaterialTypeId: number,
      workMaterialType: WorkMaterialType,
   ): Promise<ApiResource<WorkMaterialType>> {
      const response = await http.put<ApiResource<WorkMaterialType>>(
         `/employers/${employerId}/work-material-types/${workMaterialTypeId}`,
         workMaterialType,
      );
      return response.data;
   }

   async deleteWorkMaterialType(employerId: number, workMaterialTypeId: number): Promise<void> {
      const response = await http.delete(`/employers/${employerId}/work-material-types/${workMaterialTypeId}`);
      return response.data;
   }
}
